import { accountTagCategoriesClient, accountTagsClient } from '@/api/clients/index';
import { isBoolean } from 'lodash-es';

export default (accountId = null) => {
  if (!accountId) {
    return false;
  }

  return {
    name: 'tag',
    label: 'Tag',
    fetchOptions: async () => {
      try {
        const response = await accountTagCategoriesClient.list(accountId, {
          filter: {
            taggable_by: 'contacts',
          },
          include: 'tags',
          page_size: 500,
        });

        return Promise.resolve({
          data: (response?.data || []).map((category) => ({
            id: category.id,
            label: category.name,
            options: category.tags.map((tag) => ({ value: tag.id, label: tag.name })),
          })),
          meta: response?.meta || null,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getMessage: async (value, cb) => {
      if (isBoolean(value)) {
        cb(value);
      }

      let ids = value;

      if (typeof ids === 'string') {
        ids = ids.split(',');
      }

      if (Array.isArray(ids) === false) {
        ids = [ids];
      }

      try {
        const response = await accountTagsClient.list(accountId, {
          filter: {
            taggable_by: 'contacts',
            id: ids,
          },
        });

        const labels = ids.map((id) => {
          const tag = response.data.find((tagItem) => tagItem.id === id);

          return tag ? tag.name : id;
        });

        return Promise.resolve(cb(labels));
      } catch (error) {
        return Promise.resolve(cb(value));
      }
    },
    filters: [
      {
        name: 'has_tag',
        label: "Doesn't have tag",
        input: 'none',
        value: false,
        message: () => "Doesn't have **tag**",
      },
      {
        name: 'tag_is',
        label: 'Tag is',
        input: 'grouped-chips',
        value: null,
        message: (value) => `**tag** is **${value}**`,
      },
      {
        name: 'tag_is_not',
        label: 'Tag is not',
        input: 'grouped-chips',
        value: null,
        message: (value) => `**tag** is not **${value}**`,
      },
      {
        name: 'tag_in',
        label: 'Tag is one of',
        input: 'grouped-chips:multiple',
        value: [],
        message: (value) => `**tag** is one of **${value.join(', ')}**`,
      },
      {
        name: 'tag_not_in',
        label: 'Tag is not one of',
        input: 'grouped-chips:multiple',
        value: [],
        message: (value) => `**tag** is not one of **${value.join(', ')}**`,
      },
    ],
  };
};
